import * as React from "react";
import { IconProps } from "./IconProps";

export const IconDelete = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.94296 3.33337H1.9987C1.63051 3.33337 1.33203 3.63185 1.33203 4.00004C1.33203 4.36823 1.63051 4.66671 1.9987 4.66671H2.70833L3.33351 14.0444C3.35685 14.3946 3.64772 14.6667 3.9987 14.6667H11.9987C12.3497 14.6667 12.6405 14.3946 12.6639 14.0444L13.2891 4.66671H13.9987C14.3669 4.66671 14.6654 4.36823 14.6654 4.00004C14.6654 3.63185 14.3669 3.33337 13.9987 3.33337H11.0545C10.5402 2.15636 9.3662 1.33337 7.99871 1.33337C6.63123 1.33337 5.45726 2.15636 4.94296 3.33337ZM6.50783 3.33337H9.4896C9.12317 2.92412 8.59066 2.66671 7.99871 2.66671C7.40676 2.66671 6.87426 2.92412 6.50783 3.33337ZM10.5663 4.66671H4.04462L4.6224 13.3334H11.375L11.9528 4.66671H10.5955C10.5857 4.66692 10.576 4.66692 10.5663 4.66671ZM6.66536 6.66671C7.03355 6.66671 7.33203 6.96518 7.33203 7.33337V10.6667C7.33203 11.0349 7.03355 11.3334 6.66536 11.3334C6.29717 11.3334 5.9987 11.0349 5.9987 10.6667V7.33337C5.9987 6.96518 6.29717 6.66671 6.66536 6.66671ZM9.33203 6.66671C9.70022 6.66671 9.9987 6.96518 9.9987 7.33337V10.6667C9.9987 11.0349 9.70022 11.3334 9.33203 11.3334C8.96384 11.3334 8.66536 11.0349 8.66536 10.6667V7.33337C8.66536 6.96518 8.96384 6.66671 9.33203 6.66671Z"
          fill={color}
        />
      </svg>
    );
  },
);
